/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelItemMinimalListResponse } from '../../models/travel-item-minimal-list-response';

export interface TravelControllerGetCompanionTravels$Params {
  id: number;
  limit: number;
  skip: number;
}

export function travelControllerGetCompanionTravels(http: HttpClient, rootUrl: string, params: TravelControllerGetCompanionTravels$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItemMinimalListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetCompanionTravels.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItemMinimalListResponse;
      }>;
    })
  );
}

travelControllerGetCompanionTravels.PATH = '/travel/companion/{id}/travels';
